import { Toggle as TogglePrimitive } from '@base-ui/react/toggle';
import type { VariantProps } from 'class-variance-authority';
import { cn } from '../../common/functions/cn';
import { toggleVariants } from './toggle-variants';

export type ToggleVariant = NonNullable<VariantProps<typeof toggleVariants>>['variant'];
export type ToggleSize = NonNullable<VariantProps<typeof toggleVariants>>['size'];

const Toggle = ({
  className,
  variant = 'default',
  size = 'default',
  ...props
}: TogglePrimitive.Props & VariantProps<typeof toggleVariants>) => {
  return <TogglePrimitive data-slot="toggle" className={cn(toggleVariants({ variant, size, className }))} {...props} />;
};

export { Toggle };
